module.exports = __webpack_public_path__ + "static/media/meta.bee9880b.svg";